// extracted by mini-css-extract-plugin
export default {"input":"viewPlans_input__0CN-f","removePrice":"viewPlans_removePrice__BGnhU","settingBtn":"viewPlans_settingBtn__PwyTB"};